// used as @Module/@Mutation decorators
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

/**
 * Global confirmation prompts. UI is rendered via SweetAlert in
 * BaseConfirmationDialog (mounted from App.vue) when setDialog runs.
 */
@Module({
  namespaced: true,
  name: 'ConfirmationDialogModule'
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default class ConfirmationDialogModule extends VuexModule {
  title = 'Xác nhận';
  message = 'Bạn có chắc chắn muốn thực hiện hành động này?';
  confirmText = 'Đồng ý';
  cancelText = 'Hủy bỏ';
  isShow = false;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onConfirm = () => {};

  get isDialogOpen(): boolean {
    return this.isShow;
  }

  get getDialogTitle(): string {
    return this.title;
  }

  get getDialogMessage(): string {
    return this.message;
  }

  get getConfirmText(): string {
    return this.confirmText;
  }

  get getCancelText(): string {
    return this.cancelText;
  }

  get getOnConfirm(): () => void {
    return this.onConfirm;
  }

  @Mutation
  setDialog({
    cancelText,
    cancelButtonText,
    confirmText,
    confirmButtonText,
    message = 'Bạn có chắc chắn muốn thực hiện hành động này?',
    title = 'Xác nhận',
    onConfirm,
  }: {
    title?: string;
    message?: string;
    confirmText?: string;
    confirmButtonText?: string;
    cancelText?: string;
    cancelButtonText?: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }) {
    this.title = title;
    this.message = message;
    this.confirmText = confirmText ?? confirmButtonText ?? 'OK';
    this.cancelText = cancelText ?? cancelButtonText ?? 'Hủy';
    this.isShow = true;
    this.onConfirm = onConfirm;
  }

  @Mutation
  closeDialog() {
    this.isShow = false;
  }
}
